export default "__VITE_ASSET__CIbrKiDu__"